import styled from "styled-components"

export const RegisterWrapper = styled.div`
  min-height: 100vh;
  height: auto;
  width: 100vw;
  max-width: 100%;
  display: flex;
  background-color: ${(props) => props.theme.background.secondary};
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.large};
  overflow-x: hidden;
  > img {
    width: 10rem;
    height: auto;
    margin-top: ${(props) => props.theme.spacing.large};
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    gap: ${(props) => props.theme.spacing.medium};
    align-items: center;
    justify-content: flex-start;
    > img {
      width: 8rem;
      margin-top: ${(props) => props.theme.spacing.medium};
    }
  }
`;

export const LoginLogo = styled.div`
  border-radius: 5px;
  border: 1px solid white;
  background-color: ${(p) => p.theme.background.primary};
  display: flex;
  width: 10rem !important;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 2rem;
  > img {
    width: auto;
    height: 2.5rem;
  }
`;

export const RegisterDisplayer = styled.div`
  height: auto;
  min-height: 20rem;
  width: 30rem;
  max-width: 100%;
  display: flex;
  background-color: #fff !important;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: ${(props) => props.theme.spacing.large};
  background-color: transparent;
  border-radius: ${(props) => props.theme.box.borderRadius};
  border: 1px solid ${(props) => props.theme.colors.border};
  margin-left: auto;
  margin-right: auto;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    width: 90%;
    border: 0;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const AnimatedBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;

  @keyframes blob {
    0% { transform: translate(0px, 0px) scale(1); }
    33% { transform: translate(30px, -50px) scale(1.1); }
    66% { transform: translate(-20px, 20px) scale(0.9); }
    100% { transform: translate(0px, 0px) scale(1); }
  }

  .blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    mix-blend-mode: overlay;
    opacity: 0.1;
    animation: blob 7s infinite;
  }

  .blob-1 {
    top: 0;
    left: 25%;
    width: 24rem;
    height: 24rem;
    background-color: #3b82f6;
    animation-delay: 0s;
  }

  .blob-2 {
    top: 0;
    right: 25%;
    width: 24rem;
    height: 24rem;
    background-color: #a855f7;
    animation-delay: 2s;
  }

  .blob-3 {
    bottom: -8rem;
    left: 33%;
    width: 24rem;
    height: 24rem;
    background-color: #34d399;
    animation-delay: 4s;
  }
`;
